import { render } from "./MerchantManagement.vue?vue&type=template&id=33287154&scoped=true"
import script from "./MerchantManagement.vue?vue&type=script&lang=js"
export * from "./MerchantManagement.vue?vue&type=script&lang=js"

import "./MerchantManagement.vue?vue&type=style&index=0&id=33287154&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33287154"]])

export default __exports__